export const toLocalInputValue = (isoOrLocal: string) => {
    // datetime-local forventer: YYYY-MM-DDTHH:mm
    if (!isoOrLocal) return "";
    const d = new Date(isoOrLocal);
    if (Number.isNaN(d.getTime())) return isoOrLocal; // hvis det allerede er local-string
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
        d.getHours()
    )}:${pad(d.getMinutes())}`;
};

export const formatDateTime24 = (dateTimeStr: string) => {
    if (!dateTimeStr) return "-";
    const date = new Date(dateTimeStr);
    return date.toLocaleString(undefined, {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
};

export const isExpiredEnd = (ticketTimeEnd?: string | null) => {
    if (!ticketTimeEnd) return false;
    const d = new Date(ticketTimeEnd);
    if (Number.isNaN(d.getTime())) return false;
    return d.getTime() < Date.now();
};

export const fromLocalInputValue = (localValue?: string | null) => {
    if (!localValue) return null;

    // datetime-local giver normalt: YYYY-MM-DDTHH:mm
    // vi gemmer som lokal datetime-string uden Z
    return localValue.length === 16 ? `${localValue}:00` : localValue;
};